import { render } from "./Details.vue?vue&type=template&id=44c1f820&scoped=true&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=44c1f820&lang=less"
import "./Details.vue?vue&type=style&index=1&id=44c1f820&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c1f820"]])

export default __exports__